/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MicrophoneSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABj0lEQVR4nNWVsUoDQRBAAwoqiDaKvWKjhXbaXXtw2ZlJYDOTKASt/BULLdR/EP0DsTOk0yKIfyCCRtLYqBgju3dCjJe7TS4WHlxxtzfv7c7szuVy/+3K58tzgHIBxPvOQUGxvKxQThXyIxC3APmMiJdi4cQNIOkYiTMcUJ5s0I+bm0GxshgLJ26YZycBoJz/hktHIbcVcT4T3AqImzGCTyDZM+O+1vNDw0PBH8JjBKOF9whGA1ckdUCudQsUchtIdpMK2huXMGNumWDf35qxgcjPaXCt9XQ4EXlxWAFfWwDIRhQ8mwS3MYXSphWQ3KULUA7Cj/nw+13aPgeU42jsyLUtfCiSbRd4UCitAcmrrRPolVSBXYWSBRc4YmVdIT9EG+EkN8iVUNApUx+TFoX8HuX+0qtWJzPDAUo7CuWtux+ZvPu+P5EZHtja2PNgWvGtASslqwOlJe2EQjTzgaCu8EyCxENEUo/7H4SpcmgNWusxQLnpf4i41k+gSK5SBWYHAMm9kQzdcl0knueN/wX8C+4zdJXgF6pkAAAAAElFTkSuQmCC)
 */
export const MicrophoneSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m2.7 22.7 20-20a1 1 0 0 0-1.4-1.4l-20 20a1 1 0 1 0 1.4 1.4ZM10.8 17.32c-.21.21-.1.58.2.62V20H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-2.06A8 8 0 0 0 20 10a1 1 0 0 0-2 0c0 1.45-.52 2.79-1.38 3.83l-.02.02A5.99 5.99 0 0 1 12.32 16a.52.52 0 0 0-.34.15l-1.18 1.18ZM15.36 4.52c.15-.15.19-.38.08-.56A4 4 0 0 0 8 6v4c0 .3.03.58.1.86.07.34.49.43.74.18l6.52-6.52ZM5.06 13.98c.16.28.53.31.75.09l.75-.75c.16-.16.19-.4.08-.61A5.97 5.97 0 0 1 6 10a1 1 0 0 0-2 0c0 1.45.39 2.81 1.06 3.98Z"
        className={colorClass}
      />
    </svg>
  );
};
